// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/journey-log-practices.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/journey-log-practices/journey-log-practices.js';

mount([g0]);
